import { Loader2 } from 'lucide-react';
import React from 'react';

export const LoadingSpinner: React.FC = () => (
  <div className="flex justify-center items-center py-20">
    <Loader2 className="animate-spin text-yellow-500" size={56} strokeWidth={3} />
  </div>
);